import React from 'react'
import { Stack, Typography } from '@mui/material'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined'
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined'
import EventOutlinedIcon from '@mui/icons-material/EventOutlined'
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined'
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined'
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import Inventory2Icon from '@mui/icons-material/Inventory2'
import MedicalServicesIcon from '@mui/icons-material/MedicalServices'

// Board tabs - must match BOARD_GROUPS in
// server/src/helpers/makeReady/boardPage.js (bags = assets whose category
// names a bag, e.g. "Medical Bag").
export const BOARD_GROUPS = [
  { key: 'vehicles', label: 'Vehicles', singular: 'vehicle', Icon: DirectionsCarIcon },
  { key: 'bags', label: 'Bags', singular: 'bag', Icon: MedicalServicesIcon },
  { key: 'assets', label: 'Other assets', singular: 'asset', Icon: Inventory2Icon },
]

export const groupMeta = (key) =>
  BOARD_GROUPS.find((g) => g.key === key) || BOARD_GROUPS[0]

const LOCATION_ICONS = {
  person: PersonOutlineIcon,
  vehicle: DirectionsCarOutlinedIcon,
  bag: MedicalServicesOutlinedIcon,
  store: WarehouseOutlinedIcon,
  event: EventOutlinedIcon,
  base: HomeWorkOutlinedIcon,
  unavailable: BlockOutlinedIcon,
}

// Who has it / where it is, as worked out by the server
// (helpers/makeReady/boardLocations.js) for the rows on this page.
const BoardLocation = ({ location = [] }) => {
  if (!location.length) {
    return (
      <Stack direction="row" gap={0.5} alignItems="center">
        <PlaceOutlinedIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
        <Typography variant="caption" color="text.disabled">
          Not assigned
        </Typography>
      </Stack>
    )
  }
  return (
    <Stack gap={0.25}>
      {location.map((line, idx) => {
        const Icon = LOCATION_ICONS[line.type] || PlaceOutlinedIcon
        return (
          <Stack
            key={`${line.type}-${idx}`}
            direction="row"
            gap={0.5}
            alignItems="center"
            minWidth={0}
          >
            <Icon
              sx={{
                fontSize: 16,
                color:
                  line.type === 'unavailable' ? 'error.main' : 'text.secondary',
              }}
            />
            <Typography
              variant="caption"
              color={line.type === 'unavailable' ? 'error.main' : 'text.primary'}
              noWrap
              title={line.label}
            >
              {line.label}
            </Typography>
          </Stack>
        )
      })}
    </Stack>
  )
}

export default BoardLocation
